export const INDUSTRIES = [
  "Healthcare",
  "Real Estate",
  "Legal Services",
  "E-commerce",
  "Financial Services",
  "SaaS / Technology",
  "Construction",
  "Hospitality",
  "Food & Beverage",
  "Insurance",
  "Marketing & Advertising",
  "Logistics",
  "Education",
  "Home Services",
  "Automotive",
] as const;

export const REGIONS = ["North America", "EMEA", "APAC", "LATAM"] as const;

export const AVATAR_COLORS = [
  "#2563eb",
  "#7c3aed",
  "#0891b2",
  "#059669",
  "#d97706",
  "#dc2626",
  "#db2777",
  "#4f46e5",
  "#0d9488",
  "#65a30d",
] as const;

const FIRST_NAMES = [
  "James",
  "Maria",
  "Liam",
  "Sofia",
  "Noah",
  "Isabella",
  "Ethan",
  "Camila",
  "Miguel",
  "Ana",
  "Carlos",
  "Priya",
  "Daniel",
  "Grace",
  "Marcus",
  "Elena",
  "Ryan",
  "Ling",
  "Diego",
  "Hannah",
  "Josef",
  "Aisha",
  "Tomas",
  "Nadia",
  "Victor",
  "Chloe",
  "Andres",
  "Fatima",
  "Kevin",
  "Yasmin",
  "Paolo",
  "Zara",
  "Leo",
  "Ines",
  "Omar",
  "Julia",
];

const LAST_NAMES = [
  "Santos",
  "Reyes",
  "Cruz",
  "Bautista",
  "Villanueva",
  "Delacruz",
  "Mendoza",
  "Torres",
  "Ramirez",
  "Flores",
  "Aquino",
  "Castillo",
  "Navarro",
  "Salazar",
  "Domingo",
  "Fernandez",
  "Del Rosario",
  "Garcia",
  "Lopez",
  "Gonzales",
  "Tan",
  "Sy",
  "Lim",
  "Chen",
  "Osei",
  "Adeyemi",
  "Okafor",
  "Silva",
  "Alves",
  "Rossi",
];

export function fullName(rng: { pick: <T>(a: readonly T[]) => T }) {
  return `${rng.pick(FIRST_NAMES)} ${rng.pick(LAST_NAMES)}`;
}

export const COMPANY_SUFFIXES = ["Group", "Partners", "Holdings", "Co.", "& Associates", "Solutions", "Ventures", "Collective", "Studio", "Labs"];

const COMPANY_ROOTS = [
  "Northbridge",
  "Bluepeak",
  "Ironvale",
  "Summit",
  "Coastal",
  "Meridian",
  "Harborview",
  "Redstone",
  "Silverline",
  "Crestwood",
  "Vantage",
  "Brightfield",
  "Oakmont",
  "Pinegrove",
  "Lakeshore",
  "Cedarwood",
  "Westgate",
  "Highland",
  "Riverside",
  "Fairview",
  "Stonebridge",
  "Clearwater",
  "Ashford",
  "Brookhaven",
  "Grandview",
  "Kestrel",
  "Lumen",
  "Nova",
  "Orion",
  "Beacon",
];

export function companyName(rng: { pick: <T>(a: readonly T[]) => T }) {
  return `${rng.pick(COMPANY_ROOTS)} ${rng.pick(COMPANY_SUFFIXES)}`;
}

export const VA_ROLES = [
  "Executive Assistant",
  "Customer Support Specialist",
  "Bookkeeping Associate",
  "Social Media Manager",
  "Lead Generation Specialist",
  "Data Entry Specialist",
  "Content Writer",
  "Graphic Designer",
  "Recruiting Coordinator",
  "Project Coordinator",
  "Inside Sales Rep",
  "Marketing Assistant",
  "Transaction Coordinator",
  "Medical Billing Specialist",
  "Paralegal Assistant",
];

export const DEPARTMENT_NAMES = [
  "Sales",
  "Marketing",
  "Client Success",
  "Service Delivery",
  "Talent Acquisition",
  "People & Culture",
  "Finance",
  "Learning & Development",
  "Technology / AI",
] as const;

export const LOCATIONS = ["Manila, PH", "Cebu, PH", "Davao, PH", "Bogota, CO", "Nairobi, KE", "Remote"] as const;
